import { ParameterType } from '@/study-search/enums';

import { Filter } from '../Filter';
import { IIndexation } from '../../../interfaces';
import { EducationalFormFilterOptionValue, FilterKey } from '@studyportals/search-filters/server-side';

export class EducationalFormFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.EDUCATIONAL_FORM, ParameterType.EDUCATIONAL_FORM, []);
	}

	public canBeIndexed(): boolean {
		return (
			this.values.length === 1 &&
			(this.values.includes(EducationalFormFilterOptionValue.ACADEMIC_COURSE) ||
				this.values.includes(EducationalFormFilterOptionValue.SUMMER_SCHOOL) ||
				this.values.includes(EducationalFormFilterOptionValue.SEMESTER_STUDY_ABROAD) ||
				this.values.includes(EducationalFormFilterOptionValue.SKILL_PROFESSIONAL_COURSE))
		);
	}
}
